module.exports = __webpack_public_path__ + "uarm-images/tinymce-photoreports_big.png";